<template>
  <div class="live">
    <view-header header="Transmisja online" />
    <video-player
      v-if="liveSettings && isStreamOn && !isStreamOffline"
      :player-settings="liveSettings"
      live
    />
    <div class="live__offline" v-if="isStreamOffline">
      Aktualnie nie jest prowadzona transmisja online
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import VideoPlayer from '../components/VideoPlayer';
  import ViewHeader from '../components/ViewHeader';
  import { PortalService } from '../utils/portal-service';
  import { axios } from '../utils/axios';

  export default {
    name: 'Live',
    components: { ViewHeader, VideoPlayer },
    metaInfo: {
      meta: [
        { title: 'Portal | Transmisja online' },
        { description: 'Portal | Transmisja online' },
      ],
    },
    data() {
      return {
        isStreamOn: false,
        isStreamOffline: false,
        intervalId: null,
      };
    },
    computed: {
      ...mapState('settings', ['settings']),

      liveSettings() {
        const clientName = window.location.hostname.split('.')[0];

        return {
          startImageUrl: `https://stor-01.sesja.pl/${clientName}-public/player-start.png`,
          errorImageUrl: `https://stor-01.sesja.pl/${clientName}-public/player-error.png`,
          srcUrl: '',
          srcDownloadUrl: null,
        };
      },
    },
    async created() {
      await this.getLiveData();

      if (this.isStreamOffline) {
        this.intervalId = setInterval(() => {
          this.getLiveData();
        }, 30000);
      }
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
    methods: {
      async getLiveData() {
        await PortalService.getLive('_default_')
          .then(async res => {
            const liveUrl = res.data.url;
            this.liveSettings.srcUrl = liveUrl;
            await axios
              .head(liveUrl)
              .then(() => {
                this.isStreamOn = true;
                this.isStreamOffline = false;
                if (this.intervalId) {
                  clearInterval(this.intervalId);
                }
              })
              .catch(() => {
                this.isStreamOffline = true;
              });
          })
          .catch(() => {
            this.isStreamOffline = true;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .live {
    &__offline {
      margin-top: 16px;
      text-align: center;
      font-weight: bold;
      @include fontSize(24px);
    }
  }
</style>
